import { HashrateItem } from "@components/Charts/ChartDatasetUtils";
import { createTyper } from "@mobx/services/http";
import { DatePeriod } from "@services/http/dto";
import { ObjectResponse } from "@services/rackService";
import { Moment } from "moment-timezone";
import { castResponse, Method, RecordResponse, RequestArgs, RequestHandle } from "wl-net";
import { createDatePeriodParamsEx3 } from "./utils";

export const GetStatisticByBuilding_RequestTypes = createTyper({
  makeRequest(
    handle: RequestHandle,
    dateFrom: Moment | null,
    dateTo: Moment | null,
    id: number,
    isAdmin?: boolean
  ): RequestArgs<DatePeriod & { object_id: string }> {
    const params = {
      ...createDatePeriodParamsEx3(dateFrom, dateTo),
      object_id: ""+id,
    };
    return {
      handle,
      method: Method.Post,
      URL: `/${isAdmin ? "admin" : "user"}/miner/statistic3`,
      payload: params,
    };
  },
  makeResponse: castResponse<RecordResponse<HashrateItem[]>>,
});

export const GetBuilding_RequestTypes = createTyper({
  makeRequest(handle: RequestHandle, objectID: number) {
    return {
      handle,
      method: Method.Post,
      URL: "/admin/object/get",
      payload: { id: objectID },
    }
  },
  makeResponse: castResponse<RecordResponse<ObjectResponse>>,
});